// extracted by mini-css-extract-plugin
export default {"content":"ProfessionStep_content__gxFo-","title":"ProfessionStep_title__plLdb","description":"ProfessionStep_description__4IDv7"};